var _excluded = ["className"],
  _excluded2 = ["getListboxProps", "descendants", "htmlProps"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["setGroupTitleId", "id"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef } from 'react';
import { useEffect } from 'react';
import { forwardRef, omitThemingProps, StylesProvider, tqc, useMultiStyleConfig, useStyles } from '../../system';
import { runIfFn, cx, __DEV__ } from '../../utils';
import { useListbox, useListboxItem, ListBoxDescendantsContextProvider, ListboxProvider, ListboxGroupProvider, useListboxGroupContext, useListboxGroup } from './use-listbox';
export var Listbox = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var styles = useMultiStyleConfig('Listbox', rest);
  var ownProps = omitThemingProps(rest);
  var listboxRef = useRef(null);
  var _useListbox = useListbox(ownProps, listboxRef),
    {
      getListboxProps,
      descendants,
      htmlProps
    } = _useListbox,
    context = _objectWithoutProperties(_useListbox, _excluded2);
  return /*#__PURE__*/React.createElement(ListBoxDescendantsContextProvider, {
    value: descendants
  }, /*#__PURE__*/React.createElement(ListboxProvider, {
    value: context
  }, /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    className: cx('tqc-listbox', className)
  }, getListboxProps(htmlProps), htmlProps, {
    __css: styles.container
  }), props.children))));
});
if (__DEV__) {
  Listbox.displayName = 'Listbox';
}
export var ListboxItem = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  var {
    isSelected,
    getItemProps,
    htmlProps
  } = useListboxItem(rest);
  var styles = useStyles();
  var itemProps = getItemProps(rest, ref);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    className: cx('tqc-listbox__item', className)
  }, itemProps, htmlProps, {
    __css: styles.item
  }), runIfFn(props.children, {
    isSelected: isSelected
  }));
});
if (__DEV__) {
  ListboxItem.displayName = 'ListboxItem';
}
export var ListboxGroup = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  var {
    getListboxGroupProps,
    getListboxGroupTitleProps,
    htmlProps
  } = useListboxGroup(rest);
  return /*#__PURE__*/React.createElement(ListboxGroupProvider, {
    value: {
      getListboxGroupTitleProps
    }
  }, /*#__PURE__*/React.createElement(tqc.div, _extends({
    className: cx('tqc-listbox__group', className)
  }, getListboxGroupProps(), htmlProps, {
    ref: ref
  }), props.children));
});
if (__DEV__) {
  ListboxGroup.displayName = 'ListboxGroup';
}
export var ListboxGroupTitle = forwardRef((props, ref) => {
  var {
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded5);
  var styles = useStyles();
  var {
    getListboxGroupTitleProps
  } = useListboxGroupContext();
  var _getListboxGroupTitle = getListboxGroupTitleProps(rest),
    {
      setGroupTitleId,
      id
    } = _getListboxGroupTitle,
    htmlProps = _objectWithoutProperties(_getListboxGroupTitle, _excluded6);

  /**
   * Associate this group id with the parent ListboxGroup
   */
  useEffect(() => {
    setGroupTitleId(id);
  }, [id, setGroupTitleId]);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    className: cx('tqc-listbox__group-title', className),
    id: id,
    __css: styles.groupTitle
  }, htmlProps, {
    ref: ref
  }), props.children);
});
if (__DEV__) {
  ListboxGroupTitle.displayName = 'ListboxGroupTitle';
}